import React from "react";

const Footer = ({
  className = "footer-area",
  scrollToTopText = "Back to Top",
  scrollToTopTarget = "#header",
}) => {
  return (
    <footer className={`${className}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="footer-content d-flex flex-wrap justify-content-center justify-content-md-between align-items-center py-4">

              {/* Left - Branding */}
              <div className="copyright">
                © {new Date().getFullYear()} <strong>Aman Tripathi</strong>.  
                All Rights Reserved. 
              </div>

              

              {/* Right - Scroll */}
              <div className="scroll-to-top mt-3 mt-md-0">
                <a href={scrollToTopTarget} className="smooth-anchor">
                  {scrollToTopText} ↑
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;